import * as React from 'react';

import { Label } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface IEscrowLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  dark?: boolean;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

// eslint-disable-next-line react/display-name
export const EscrowLabel = React.forwardRef((props: IEscrowLabelProps, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div className={styles['label']} {...props} onClick={props.onClick} ref={ref}>
      <Label background={props.dark ? 'overlay-control-default' : 'surface-neutral-default'} color="theme-dark">
        Эскроу
      </Label>
    </div>
  );
});

EscrowLabel.displayName = 'EscrowLabel';
